import { createContext, useState, useCallback, useContext } from 'react';

export const DownloadCenterContext = createContext();

export function DownloadCenterProvider({ children }) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const setDateRange = useCallback((range) => {
    if (range) {
      setStartDate(range[0]);
      setEndDate(range[1]);
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  }, []);

  const clearDateRange = useCallback(() => {
    setStartDate(null);
    setEndDate(null);
  }, []);

  return (
    <DownloadCenterContext.Provider
      value={{
        startDate,
        endDate,
        setDateRange,
        clearDateRange,
      }}
    >
      {children}
    </DownloadCenterContext.Provider>
  );
}

export const useDownloadCenter = () => useContext(DownloadCenterContext);
